export default __webpack_public_path__ + "static/media/slot18.636daeac.png";